import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration } from '../models/configuration';

@Injectable({ providedIn: 'root' })
export class ConfigService {
    private _config:  { [key: string]: any; } = {};
    private _configCustom:  { [key: string]: string; } = {};

    public constructor(private http: HttpClient) {}

    public isTrue(x: any) {
        return (x && x.toString().toLowerCase() === 'true') || false;
    }

    public load() {
        return new Promise((resolve) => {
            this.http.get('config.json')
            .toPromise()
            .then((r) => {
                if (r) {
                    let config = r as Configuration;
                    this._config = {
                        apiUrl: config.apiUrl,
                        description: config.description,
                        title: config.title,
                        wcPortalUrl: config.wcPortalUrl
                    };
                    resolve(true);
                }
            });
          });
    }

    public get(key: keyof Configuration) {
        if (this._config && this._config.hasOwnProperty(key)) {
            return this._config[key];
        } else {
            return '';
        }
    }

    public setCustom(key: any, val: any): void {
        this._configCustom[key] = val;
    }

    public getCustom(key: any) {
        return this._configCustom[key];
    }

    public setLocal(key: string, value: any): void {
        if (value !== undefined) {
            localStorage.setItem(key, this.serialize(value));
        }
    }

    public getLocal(key: string, createFunc?: Function): any {
        let itm = localStorage.getItem(key);
        if (itm) {
            return this.deserialize(itm);
        } else {
            itm = (createFunc || (() => void 0))();
            this.setLocal(key, itm);
            return (itm && this.deserialize(itm)) || void 0;
        }
    }

    private serialize(value: any): any {
        return JSON.stringify(value);
    }

    private deserialize(value: any): any {
        return JSON.parse(value);
    }
}